/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOrganisationPrivacySettingsDataSchema = z.object({
	candidateRetentionMonths: z.number().nullable().optional(),
	autoApproveDataRemovalRequests: z.boolean().optional(),
})

export type UpdateOrganisationPrivacySettingsDataSchema = z.infer<typeof updateOrganisationPrivacySettingsDataSchema>
